/*
 * @Author: zl
 * @Date: 2022-03-29 11:50:49
 * @LastEditTime: 2022-04-25 14:24:42
 * @LastEditors: zl
 * @Description: 三方巡查
 */
import request from '@/api/request'

/**
 * 三方巡查 - 分页查询
 * 接口管理员： 郑志会
 */
export const selTripartiteInspectionPageList = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/selTripartiteInspectionPageList',
        method: 'post',
        data,
    })
}
/**
 * 描述： 三方巡查 - 选择回显页面
 * 接口管理员：俞祥东
 */
export const selProjectPackDetailInfo = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/selProjectPackDetailInfo',
        method: 'post',
        data
    })
}
/**
 * 描述： 三方巡查 - 意见书 / 报告基本信息
 * 接口管理员：俞祥东
 */
export const selTripartiteInspectionBaseInfo = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/selTripartiteInspectionBaseInfo',
        method: 'post',
        data
    })
}
/**
 * 描述： 三方巡查 - 回复操作日志
 * 接口管理员：俞祥东
 */
export const selReplyOperateDetailInfo = function (data) {
    return request({
        url: 'audit/auditreportreply/selReplyOperateDetailInfo',
        method: 'post',
        data
    })
}
/**
 * 描述： 表单信息获取
 * 接口管理员：俞祥东
 */
export const checkProjectPackDetail = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/checkProjectPackDetail',
        method: 'post',
        data
    })
}
/**
 * 描述： 三巡单位列表获取
 * 接口管理员：俞祥东
 */
export const getTripartiteInspectionPatrolUnitList = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/getTripartiteInspectionPatrolUnitList',
        method: 'post',
        data
    })
}
/**
 * 描述： 三方巡查 -- 东部新中心建设项目三方巡查报表统计
 * 接口管理员：俞祥东
 */
export const getInspectionReportCounts = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/getInspectionReportCounts',
        method: 'post',
        data
    })
}
/**
 * 描述： 三方巡查 -- 详情统计列表查询
 * 接口管理员：俞祥东
 */
export const getInspectionReportList = function (data) {
    return request({
        url: 'audit/audittripartiteinspection/getInspectionReportList',
        method: 'post',
        data
    })
}